'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var isLocalhost = function () {
    var _a, _b, _c;
    return Boolean(((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === "localhost" ||
        // [::1] is the IPv6 localhost address.
        ((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.hostname) === "[::1]" ||
        (
        // 127.0.0.1/8 is considered localhost for IPv4.
        (_c = window === null || window === void 0 ? void 0 : window.location) === null || _c === void 0 ? void 0 : _c.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)));
};
var register = function (config) {
    return new Promise(function (resolve, reject) {
        if (!config.swUrl) {
            config.swUrl = "/service-worker.js";
        }
        if ("serviceWorker" in navigator) {
            if (isLocalhost()) {
                // This is running on localhost. Let's check if a service worker still exists or not.
                return checkValidServiceWorker(config)
                    .then(function () {
                    navigator.serviceWorker.ready
                        .then(resolve)
                        .catch(reject);
                })
                    .catch(reject);
            }
            else {
                return registerValidSW(config)
                    .then(resolve)
                    .catch(reject);
            }
        }
        return reject('serviceworker not supported');
    });
};
var registerValidSW = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var registration_1, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, navigator.serviceWorker.register(config.swUrl)];
            case 1:
                registration_1 = _a.sent();
                registration_1.onupdatefound = function () {
                    var installingWorker = registration_1.installing;
                    if (installingWorker == null) {
                        return false;
                    }
                    installingWorker.onstatechange = function () {
                        if (installingWorker.state === "installed") {
                            if (navigator.serviceWorker.controller) {
                                // Execute callback
                                // sw will only work if the user closes the tab and opens it again
                                // my sugestion: redirect to a url with loading animation and timeout, then come back here again
                                if (config && config.onUpdate) {
                                    config.onUpdate(registration_1);
                                }
                            }
                            else {
                                // At this point, everything has been precached.
                                // It's the perfect time to display a
                                // "Content is cached for offline use." message.
                                // configure your callback
                                if (config && config.onSuccess) {
                                    config.onSuccess(registration_1);
                                }
                            }
                        }
                    };
                    return registration_1;
                };
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                if (config && config.onError)
                    config.onError(error_1);
                throw new Error(error_1.message);
            case 3: return [2 /*return*/];
        }
    });
}); };
var checkValidServiceWorker = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var response, contentType;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetch(config.swUrl, {
                        headers: { "Service-Worker": "script" },
                    })];
            case 1:
                response = _a.sent();
                contentType = response.headers.get("content-type");
                if (response.status === 404 ||
                    (contentType != null && contentType.indexOf("javascript") === -1)) {
                    // No service worker found. Probably a different app. Reload the page.
                    return [2 /*return*/, navigator.serviceWorker.ready.then(function (registration) {
                            registration.unregister().then(function () {
                                window.location.reload();
                                return false;
                            });
                        })];
                }
                else {
                    // Service worker found. Proceed as normal.
                    return [2 /*return*/, registerValidSW(config)];
                }
            case 2:
                _a.sent();
                // Page is offline.
                if (config && config.onOffline)
                    config.onOffline();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
function unregister() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready
            .then(function (registration) {
            registration.unregister();
        })
            .catch(function (error) {
            console.error(error.message);
        });
    }
}

function useRegistration(props) {
    var _a = React.useState(), registration = _a[0], setRegistration = _a[1];
    var _b = React.useState(), promptInstall = _b[0], setPromptInstall = _b[1];
    var _c = React.useState(), isInstalled = _c[0], setIsInstalled = _c[1];
    var _d = React.useState(), supports = _d[0], setSupports = _d[1];
    var _e = React.useState(false), done = _e[0], setDone = _e[1];
    var debounce;
    React.useEffect(function () {
        var handleFinally = function () {
            if (debounce)
                clearTimeout(debounce);
            debounce = setTimeout(function () {
                setDone(true);
            }, 355);
        };
        var handler = function () {
            register(props.config)
                .then(function (regis) {
                setRegistration(regis);
            })
                .catch(function (err) {
                var _a;
                if ((_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.onError) {
                    setSupports(false);
                    return props.config.onError(err);
                }
            })
                .finally(handleFinally);
        };
        if (typeof window !== 'undefined') {
            handler();
        }
    }, [props]);
    React.useEffect(function () {
        var checkSupport = function (e) {
            setPromptInstall(e);
        };
        var appInstalled = function () {
            setDone(true);
            setSupports(true);
            setIsInstalled("standalone");
        };
        if (typeof window !== undefined) {
            if ("serviceWorker" in navigator) {
                setIsInstalled("none");
                setSupports(true);
                window.addEventListener("beforeinstallprompt", checkSupport);
            }
            if (window.matchMedia("(display-mode: standalone)").matches) {
                appInstalled();
            }
            window.addEventListener("appinstalled", appInstalled);
        }
        return function () {
            if (typeof window !== undefined) {
                window.removeEventListener("beforeinstallprompt", checkSupport);
                window.removeEventListener("appinstalled", appInstalled);
            }
        };
    }, [registration]);
    var onClickInstall = React.useCallback(function (evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
        }
        promptInstall === null || promptInstall === void 0 ? void 0 : promptInstall.prompt().then(function (e) {
            var _a;
            if ((_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.onPrompt) {
                return props.config.onPrompt(e);
            }
        }).catch(function (e) {
            var _a;
            if ((_a = props === null || props === void 0 ? void 0 : props.config) === null || _a === void 0 ? void 0 : _a.onPrompt) {
                return props.config.onPrompt(e);
            }
        });
    }, [promptInstall]);
    return {
        install: onClickInstall,
        supports: supports,
        isInstalled: isInstalled,
        registration: registration,
        done: done
    };
}

var PwaContext = React.createContext({});
var usePwa = function () { return React.useContext(PwaContext); };
var ReactPwa = function (props) {
    var _a = useRegistration(props), done = _a.done, registration = __rest(_a, ["done"]);
    return (React__default["default"].createElement(PwaContext.Provider, { value: registration }, !done && props.suspense ? props.suspense : props.children));
};
var index = React__default["default"].memo(ReactPwa);

exports.PwaContext = PwaContext;
exports["default"] = index;
exports.register = register;
exports.unregister = unregister;
exports.usePwa = usePwa;
